import React, { useEffect, useContext } from 'react';
import { QuizContext } from "./ConfigurableQuizContainer";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import During from "./QuizDuring";
import Results from "./QuizResults";

export default function QuizRouter() {

  const { restartQuiz, lastPageID, accruedCards } = useContext(QuizContext);
  const location = useLocation();
  const thisURL = new URLSearchParams(location.search);

  useEffect(() => {
    if (location.pathname == "/") {
      restartQuiz();
      document.getElementById(lastPageID).style.display = "none";
    } else if (location.pathname == "/results") {
      document.querySelector('.container-fluid.email-results-bar').style.display = "none";
      document.getElementById(lastPageID).style.display = "block";
    } else {
      document.getElementById(lastPageID).style.display = "none";
    }
  }, [location])

  return(
      <Routes>
        <Route path="/" element={ <During /> } />
        { accruedCards.length ?
          <Route path="results" element={ <Results /> } /> :
          <Route path="results" element={ <Navigate replace to="/" />} /> 
        }
        { thisURL.get('s') && thisURL.get('a') ?
          <Route path="share" element={ <Results /> } /> :
          <Route path="share" element={ <Navigate replace to="/" />} />
        }
        <Route path="*"  element={ <During /> } />
      </Routes>
    )
}

